import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const contactUsApi = createApi({
    reducerPath: "contactUsApi",
    baseQuery: axiosBaseQuerySpotfinder({
        baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
    }),
    tagTypes: ["contactUs"],
    endpoints: (builder) => ({
        addQueryContactUs: builder.mutation({
            query: (body) => {
                return {
                    url: spotFinder.contactUsController.addQueryContactUs,
                    method: "POST",
                    body: body.payload,
                };
            },
        }),

    }),
});

export const { useAddQueryContactUsMutation } =contactUsApi;
